import React from 'react';
import { Navigate } from 'react-router-dom';

import { AuthState } from '../../common/auth';
import { useAuth } from '../../common/hooks/useAuth';
import { SignInDialog } from '../components/SignIn/SignInDialog';
import { useSpdCore } from '../../common/hooks/useSpdCore';

export const SignInView: React.FC = () => {
  const auth = useAuth();
  const spdApi = useSpdCore();

  if (auth.state === AuthState.Unknown) {
    return null;
  }

  if (auth.state === AuthState.LoggedIn) {
    return <Navigate to="/" replace />;
  }

  const onSignIn = async (username: string, password: string) => {
    return await spdApi.signIn.signIn(username, password);
  };

  return <SignInDialog onSignIn={onSignIn} open={true} />;
};
